import { Layout } from "antd";
import { Messages } from "features/messages";
import Header from "layouts/agencyPortal/dashboard/header";
import styled from "styled-components";

const StyledInnerLayout = styled(Layout)`
  top: 64px;
  position: absolute;
  width: 100%;
  overflow: hidden;
`;

export default function MessagesPage() {
  return (
    <Layout>
      <Header />
      <StyledInnerLayout>
        <Messages />
      </StyledInnerLayout>
    </Layout>
  );
}
